import { createSelector } from 'reselect';

import { getUIDetails } from './general';

const getTranslationsItem = createSelector(getUIDetails, details => details.translations);

export const getTranslations = createSelector(getTranslationsItem, translations => translations.data);

export const isLoading = createSelector(getTranslationsItem, translations => translations.isLoading);

export const getError = createSelector(getTranslationsItem, translations => translations.apiError);
